import { parseEntityItemId } from '@wix/a11y-rules';
import _ from 'lodash';
import { modify } from 'ricos-content/libs/modify';
import { buildSingleNode } from '../../utils/build-single-rich-content-node';
const isCoverImageItem = (item, experiencesMap) => {
  if (item.entityId) {
    return item.entityId === item.id;
  }
  return experiencesMap.has(item.id);
};
export const buildTableReservationsExperiencesBulkUpdatePayload = (altTextData, experiencesMap) => {
  const payload = [];
  const payloadByExperienceId = new Map();
  const coverImageUpdates = [];
  const richContentUpdates = [];
  altTextData.forEach(item => {
    if (isCoverImageItem(item, experiencesMap)) {
      coverImageUpdates.push(item);
    } else {
      richContentUpdates.push(item);
    }
  });
  coverImageUpdates.forEach(item => {
    var _experience$configura;
    const experienceId = item.id;
    const experience = experiencesMap.get(experienceId);
    const originalCoverImage = experience == null || (_experience$configura = experience.configuration) == null || (_experience$configura = _experience$configura.displayInfo) == null ? void 0 : _experience$configura.coverImage;
    if (!experience || !originalCoverImage) {
      return;
    }
    const masked = {
      experience: {
        configuration: {
          displayInfo: {
            coverImage: {
              ...originalCoverImage,
              altText: item.alt
            }
          }
        },
        id: experience.id,
        revision: experience.revision
      }
    };
    payload.push(masked);
    payloadByExperienceId.set(experienceId, masked);
  });
  const richItemsByExperienceId = _.groupBy(richContentUpdates, item => {
    if (item.entityId) {
      return item.entityId;
    }
    const {
      entities
    } = parseEntityItemId(item.id, 2);
    return entities[0] ?? '';
  });
  Object.entries(richItemsByExperienceId).forEach(_ref => {
    var _experience$configura2, _existing$experience;
    let [experienceId, itemsForExperience] = _ref;
    const experience = experienceId ? experiencesMap.get(experienceId) : undefined;
    const richContent = experience == null || (_experience$configura2 = experience.configuration) == null || (_experience$configura2 = _experience$configura2.displayInfo) == null ? void 0 : _experience$configura2.richContent;
    if (!experience || !richContent) {
      return;
    }
    const mediaUpdates = itemsForExperience.map(item => {
      const {
        itemId: imageId,
        entities
      } = parseEntityItemId(item.id, 2);
      const [, nodeId] = entities;
      return {
        alt: item.alt,
        entityId: experienceId,
        imageId,
        isDecorative: item.isDecorative,
        nodeId
      };
    });
    const updatesByNodeId = _.groupBy(mediaUpdates, upd => upd.nodeId);
    const updatedRichContent = modify(richContent).filter(node => updatesByNodeId[node.id] !== undefined).set(node => buildSingleNode(node, updatesByNodeId[node.id]));
    const existing = payloadByExperienceId.get(experienceId);
    if (existing != null && (_existing$experience = existing.experience) != null && (_existing$experience = _existing$experience.configuration) != null && _existing$experience.displayInfo) {
      // Merge into existing cover-image entry for this experience.
      existing.experience.configuration.displayInfo.richContent = updatedRichContent;
    } else {
      const masked = {
        experience: {
          configuration: {
            displayInfo: {
              richContent: updatedRichContent
            }
          },
          id: experience.id,
          revision: experience.revision
        }
      };
      payload.push(masked);
      payloadByExperienceId.set(experienceId, masked);
    }
  });
  return payload;
};
//# sourceMappingURL=bulk-update-table-reservations-experiences-alt-text-payload-builder.js.map